/* eslint-disable @typescript-eslint/no-unused-vars */
import createActions from '../../config/actions/createActions';
import { action } from '@play-co/replicant';
import { match2BundleSaleReset } from './match2-bundlesale.modifiers';
import {
  match2BundleSaleGetCurrentEventItems,
  match2BundleSaleGetPurchasedItems,
} from './match2-bundlesale.getters';

/** Development mode only, not allowed in production */
export const match2BundleSaleCheats = createActions({
  /**
   * Reset bundle sale, making items available for purchase again
   */
  cheat_bundleSaleReset: action((state, _: void, api) => {
    match2BundleSaleReset(state);
  }),
  /**
   * Reset bundle sale, making items available for purchase again
   */
  cheat_bundlePurchaseNextItems: action((state, amount: number, api) => {
    if (!state.match2.bundleSale) return;
    const allItems = match2BundleSaleGetCurrentEventItems(
      state,
      api.date.now(),
    );
    const purchased = match2BundleSaleGetPurchasedItems(state, api.date.now());
    const available = allItems.filter((item) => !purchased.includes(item));
    const items = available.slice(0, amount);
    for (const item of items) {
      if (!state.match2.bundleSale.purchased.includes(item)) {
        state.match2.bundleSale.purchased.push(item);
      }
    }
    state.match2.bundleSale.lastPurchasedAt = api.date.now();
  }),
});
